var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup"},[(_vm.name)?_c('h2',{staticClass:"popup-title"},[_vm._v("\n\t\t"+_vm._s(_vm.name)+"\n\t")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popup-content"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"buttons"},[_vm._t("buttons")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }